import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  filter: {
    maxWidth: pxToRem(223),
    width: pxToRem(120),
    selectors: {
      '& span': {
        borderWidth: 0,
        borderRadius: 0,
        borderBottomColor: theme.palette.themePrimary,
        borderBottomWidth: pxToRem(1),
        fontWeight: 'normal',
      },
    },
  },
  filterAndSearchContainer: {
    display: 'flex',
  },
  selectDeselectButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  bundleButtonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  textButton: {
    paddingRight: 0,
  },
  search: {
    marginBottom: pxToRem(16),
    maxWidth: pxToRem(320),
    selectors: {
      '&::before': {
        content: '" "',
        position: 'absolute',
        height: '70%',
        width: pxToRem(1),
        top: '15%',
        left: '-1px',
        backgroundColor: theme.palette.neutralQuaternary,
      },
    },
  },
  resultsMessage: {
    marginBottom: pxToRem(8),
  },
  noResultsSentence: {
    marginTop: pxToRem(5),
    fontWeight: 400,
  },
  iconColumn: {
    height: pxToRem(20),
    width: pxToRem(20),
    textAlign: 'center',
    fontSize: '1rem',
  },
  cancelButton: {
    marginRight: pxToRem(20),
    fontWeight: 400,
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
        width: pxToRem(20),
        position: 'absolute',
      },
      '&:hover': {
        background: 'transparent',
      },
      '&:focus': {
        background: 'transparent',
      },
      '&:active': {
        background: 'transparent',
      },
    },
  },
  iconColumnHeaderSelectButton: {
    cursor: 'pointer',
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        top: pxToRem(14),
        left: pxToRem(7),
        position: 'absolute',
      },
      '&:hover': {
        background: 'transparent',
      },
      '&:focus': {
        background: 'transparent',
      },
      '&:active': {
        background: 'transparent',
      },
      '& .ms-DetailsHeader-cellName .ms-Icon': {
        fontSize: pxToRem(16),
        color: theme.palette.themePrimary,
        paddingLeft: pxToRem(1),
      },
    },
  },
  viewButton: {
    textAlign: 'center',
    selectors: {
      a: {
        textDecoration: 'none',
        fontSize: pxToRem(14),
        selectors: {
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      },
    },
  },
  selectButton: {
    height: pxToRem(34),
  },
  disableSelected: {
    selectors: {
      '&:disabled': {
        '.ms-Icon': {
          color: 'rgba(120, 16, 66, 0.12) !important',
        },
        background: 'none !important',
      },
    },
  },
  slash: {
    color: theme.palette.neutralQuaternaryAlt,
  },
  breadcrumbs: {
    textDecoration: 'none',
    selectors: {
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  },
  headerIcon: {
    maxHeight: pxToRem(16),
    maxWidth: pxToRem(16),
    fontSize: '1rem',
    verticalAlign: 'middle',
  },
  detailRowIconColor: {
    color: theme.palette.neutralTertiary,
  },
  countAndButtonsContainer: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'space-between',
  },
  removeButton: {
    marginLeft: '0px',
  },
  listHeader: {
    color: theme.palette.neutralDark,
    fontWeight: 300,
    fontSize: pxToRem(14),
  },
  scrollablePane: {
    selectors: {
      '& .ms-DetailsList-contentWrapper': {
        maxHeight: pxToRem(704),
        overflowY: 'auto',
        overflowX: 'hidden',
      },
    },
  },
  multipleScrollablePane: {
    selectors: {
      '& .ms-DetailsList-contentWrapper': {
        maxHeight: pxToRem(450),
        overflowY: 'auto',
        overflowX: 'hidden',
      },
    },
  },
  productText: {
    width: pxToRem(320),
    fontSize: pxToRem(12),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    paddingRight: pxToRem(20),
  },
  productName: {
    width: pxToRem(320),
    fontSize: pxToRem(14),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'wrap',
    paddingRight: pxToRem(20),
  },
});
